module.exports = __webpack_public_path__ + "static/img/home.6f5debe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home.png
// module id = P7rK
// module chunks = 1